import { AlertUtil } from './../utils/alert-util';
import { DocumentiService } from './../services/documenti.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IDocumento } from '../interfaces/IDocumento';
import { IAllegati } from '../interfaces/IAllegati';
import { DynamicDialogConfig } from 'primeng/api';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import * as Enum from '../utils/enums';
import { Util } from '../utils/util';

@Component({
  selector: 'app-documento-prefetto-modal',
  templateUrl: './documento-prefetto-modal.component.html',
  styleUrls: ['./documento-prefetto-modal.component.css']
})
export class DocumentoPrefettoModalComponent implements OnInit {
  @ViewChild('op') op: OverlayPanel

  document: IDocumento
  allegati: IAllegati[]
  attachmentUrl: string = "" // url dell'allegato
  appVersion: number

  constructor(private config: DynamicDialogConfig,
    private documentiService: DocumentiService,
    private alertUtil: AlertUtil) {
    this.document = this.config.data.documento
    this.appVersion = this.document.Versione
  }

  ngOnInit() {
    this.allegati = this.document.Allegati
  }

  /**
   * click pdf button
   * show pdf
   */
  clickButtonPdf() {
    Loading.isLoading = true

    let documentoCloned: IDocumento = {
      Id: this.document.Id,
      Nome: this.document.Nome,
      Descrizione: this.document.Descrizione,
      Tipologia: this.document.Tipologia,
      Data_scadenza: this.document.Data_scadenza,
      Documento: this.document.Documento,
      DocumentoCreato: this.document.DocumentoCreato,
      Autore: this.document.Autore,
      Versione: this.document.Versione
    }

    let reqBuilder = new RequestBuilder(documentoCloned)
    this.documentiService.showPDF(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          Util.showPdf(response)
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * open allegato in other tab
   */
  openAllegato(event: any, allegato: IAllegati) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      ModuloId: this.document.Id,
      NumeroAllegato: allegato.Numero_allegato,
      Versione:  allegato.Versione ? allegato.Versione : -1
    })

    this.documentiService.visualizzaAllegato(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          //check allegato extension
          let allegatoType = allegato.Estensione.trim()
          let allegatoNome = allegato.Nome
          if (!allegatoType) {
            allegatoType = allegatoNome.substring(allegatoNome.lastIndexOf(".") + 1);
          }
          if (allegatoType == Enum.FILE_TYPE_ENUM.PDF) {
            Util.showPdf(response)
          } else if (allegatoType == Enum.FILE_TYPE_ENUM.JPEG || allegatoType == Enum.FILE_TYPE_ENUM.JPG
            || allegatoType == Enum.FILE_TYPE_ENUM.PNG) {
            this.attachmentUrl = "data:image/" + allegatoType + ";base64," + response
            //Apertura dell'overlay panel
            this.op.toggle(event)

          } else {
            Util.downloadFile(response, allegatoType, allegatoNome)
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }
}
